import { WhatsappLogo } from "@phosphor-icons/react"

export function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/917348958352"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition-all duration-200 hover:scale-105 hover:shadow-xl"
      aria-label="Chat on WhatsApp"
    >
      <div className="p-3.5">
        <WhatsappLogo size={28} weight="fill" />
      </div>
    </a>
  )
}
